import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBedPulse, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import ProductImagesSlider from "../../Components/Slider/ProductImagesSlider";
import AllReviews from "../../Components/Reviews/AllReviews";
import ReviewBox from "../../Components/Reviews/ReviewBox";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { map, plant1, v1 } from "../../constant";
import ProductCard from "../../Components/Cards/ProductCard";
import ActionButton from "../../Components/ActionBtn/ActionButton";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import FrequentlyCard from "./FrequentlyCard";
import MainBanner from "../../Components/Banner/MainBanner";
import NutrientsProSlider from "../../Components/Slider/NutrientsProSlider";
import "../../assets/css/ProductDetails.css";
import { style } from "@mui/system";
import {
  GetProductDetailsApi,
  GetProductRatingApi,
  PostAddWishList,
  PostProductReviewApi,
} from "../../network/Network";
import { useEffect } from "react";
import { AddToCart } from "../../redux/actions/CartActions";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import swal from "sweetalert";
import DonarListModal from "../../Components/Modal/DonarListModal";

function GeneralHydroponic() {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const ImageUrlRedux = useSelector((state) => state.AuthReducer.urlData);
  const cartDataRedux = useSelector((state) => state.CartReducer.cartData);
  const Token = useSelector((state) => state.AuthReducer.token);
  const CampaignReduxData = useSelector(
    (state) => state.AuthReducer.donationCampaign
  );
  let currentUrl = window.location.href.split("/");
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [productDetails, setProductDetails] = useState(null);
  const [spinLoad, setSpinLoad] = useState(false);
  const [wishLoading, setWishLoading] = useState(false);

  const location = useLocation();
  const ParamData = location?.state?.data;

  const [active, setActive] = useState(false);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [reviewLoading, setReviewLoading] = useState(false);

  const [reviewSpin, setReviewSpin] = useState(false);
  const [reviewData, setReviewData] = useState([]);

  const [quantity, setQuantity] = useState(1);
  const [submitReview, setSubmitReview] = useState(false);
  const [selectedSize, setSelectedSize] = useState("");

  const [selectCampPrice, setSelectCampPrice] = useState("");
  const [selectCamp_id, setSelectCamp_id] = useState("");
  const [selectedSize_Id, setSelectedSize_Id] = useState("");

  const [amount, setAmount] = useState("");

  const handleRating = (rate) => {
    setRating(rate)
  };

  const SelectPacks = (e, item) => {
    if (amount == item?.price) {
      setSelectedSize("")
      setAmount("");
      setQuantity(1);
    } else {
      setAmount(item?.price);
      setQuantity(1);
      setSelectedSize(item?.size)
      setSelectedSize_Id(item?.id)
    }
  };

  useEffect(() => {
    setSpinLoad(true);
    GetProductDetailsApi(currentUrl[4])
      .then((res) => {
        setProductDetails(res?.data);
        setSpinLoad(false);
      })
      .catch((err) => {
        setSpinLoad(false);
      });
  }, [currentUrl[4]]);

  const AddWishListHandler = (e) => {
    e.preventDefault();
    setWishLoading(true);
    let data = {
      product_id: currentUrl[4],
    };
    PostAddWishList(data, Token)
      .then((res) => {
        setWishLoading(false);
        setActive(!active);
        toast.success("Product Added to your Wishlist");
      })
      .catch((err) => {
        setWishLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const AddToCartHandler = (item) => {
    if (currentUrl[3] === "premium-product") {
      if (!selectedSize) {
        toast.error("Please Select Size");
        return;
      }
      if (productDetails?.variation) {
        let newVarient = productDetails?.variation.filter(
          (val) => val.size == selectedSize
        );
        if (newVarient[0]?.qty > 0) {
          let checkItemAlreadyExist = cartDataRedux.filter(
            (val) => val?.id === item?.id
          );
          if (checkItemAlreadyExist.length > 0) {
            swal({
              title: "Item Already Exist in Cart!!!",
            });
            navigate('/cart')
          } else {
            let variant_Id = selectedSize ? productDetails?.variation.filter((val)=> val?.size == selectedSize) : ""
            let data = {
              id: item?.id,
              price: selectedSize ? VariationPrice() : productDetails?.unit_price,
              quantity: quantity,
              type:
                currentUrl[3] === "premium-product"
                  ? "single"
                  : amount
                    ? "bulk"
                    : "",
              size: selectedSize,
              campaign_price: selectCampPrice,
              campaign_id: selectCamp_id,
              productitem: item,
              deliveryDate: " ",
              addon_item: [],
              product_variant_id: variant_Id ? variant_Id[0]?.id : " ",
            };
            dispatch(AddToCart(data));
            toast("Product successfully added");
          }
        } else {
          toast("Selected Variation is out of stock");
          return;
        }
      }
    } else {
      if (!amount) {
        toast.error("Please Select your Pack");
        return;
      }
      if (productDetails?.variation) {
        let newVarient = productDetails?.variation.filter(
          (val) => val.price == amount
        );
        if (newVarient[0]?.qty > 0) {
          let checkItemAlreadyExist = cartDataRedux.filter(
            (val) => val?.id === item?.id
          );
          if (checkItemAlreadyExist.length > 0) {
            swal({
              title: "Item Already Exist in Cart!!!",
            });
          } else {
            let data = {
              id: item?.id,
              price: amount ? amount : item?.unit_price,
              quantity: quantity,
              type:
                currentUrl[3] === "premium-product"
                  ? "single"
                  : amount
                    ? "bulk"
                    : "",
              size: selectedSize ? selectedSize : quantity,
              campaign_price: selectCampPrice,
              campaign_id: selectCamp_id,
              productitem: item,
              deliveryDate: " ",
              addon_item: [],
              product_variant_id: selectedSize_Id,
            };
            dispatch(AddToCart(data));
            toast("Product successfully added");
          }
        } else {
          toast("Selected Variation is out of stock");
          return;
        }
      }
    }
  };

  const SubmitRating = (e) => {
    e.preventDefault();
    setReviewLoading(true);
    if (!rating) {
      toast.error("Please Enter Rating");
      setReviewLoading(false);
      return;
    }
    if (!comment) {
      toast.error("Please Enter Comments");
      setReviewLoading(false);
      return;
    }
    let data = {
      product_id: productDetails?.id,
      comment: comment,
      rating: rating / 20,
    };
    PostProductReviewApi(data, Token)
      .then((res) => {
        setReviewLoading(false);
        toast.success("Successfully send");
        setSubmitReview(!submitReview);
        setRating("");
        setComment("");
      })
      .catch((err) => {
        setReviewLoading(false);
        setSubmitReview(!submitReview);
        if (err?.response?.data?.message === "Unauthenticated.") {
          toast.error("Please Login");
        }
        setRating("");
        setComment("");
      });
  };

  useEffect(() => {
    setReviewSpin(true);
    GetProductRatingApi(currentUrl[4])
      .then((res) => {
        setReviewData(res?.data?.data);
        setReviewSpin(false);
      })
      .catch((err) => {
        setReviewSpin(false);
      });
  }, [submitReview]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const Increment = (id) => {
    setQuantity(quantity + 1);
  };
  const Decrement = (id) => {
    setQuantity(quantity - 1);
  };

  const filterVariationQty = () => {
    let varient = selectedSize;
    if (productDetails?.variation) {
      let newVarient = productDetails?.variation.filter(
        (val) => val?.size == varient
      );
      if (newVarient.length > 0) {
        return newVarient[0].qty ;
      }
      return ;
    }
    return ;
  };

  const VariationPrice = () => {
    let varient = selectedSize;
    if (productDetails?.variation) {
      let data = productDetails?.variation?.filter((val) => val?.size === varient)
      if (data?.length > 0) {
        return data[0]?.price;
      }
      return;
    }
    return;
  }

  if (productDetails == null) {
    return (
      <div className="container">
        <div className="row loader-container">
          {[0, 1, 2, 3, 4, 5, 7, 8, 9]?.map((item, index) => {
            return (
              <div className="col-md-12 mt-3" key={index}>
                <Skeleton count={5} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <MainBanner name={productDetails?.name} />
      <div className="product-details hypdross">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <NutrientsProSlider props={productDetails} />
            </div>
            <div
              className="col-lg-6"
              style={{ zIndex: "999", position: "relative" }}
            >
              <div style={{ zIndex: "9999" }}>
                <div className="row">
                  <div className="col-lg-6">
                    <p className="maples">{productDetails?.category?.name}</p>
                    <h3 className="productName  productName2">
                      {productDetails?.name}
                    </h3>
                  </div>
                  <div className="col-lg-6">
                    <div className="tags-right">
                      <p> Price :  ${currentUrl[3] === "premium-product" && selectedSize ? VariationPrice() : amount ? amount : productDetails?.variation[0]?.price}</p>
                      {productDetails?.current_stock > 0 ? null : (
                        <p>Out of Stock</p>
                      )}
                    </div>
                  </div>
                </div>
                <p className="desc-title">Description</p>
                <div
                  className="productDesc"
                  dangerouslySetInnerHTML={{ __html: productDetails?.details }}
                />

                {currentUrl[3] === "premium-product" ? (
                  <>
                    <div className="variations">
                      <div className="row">
                        <div className="col-md-8 mb-2">
                          <div className="form-group">
                            <label for="size">Select Size: </label>
                            <div>
                                      <select
                                        id="size"
                                        className="form-control sizeSelect "
                                        onChange={(e) => {
                                          setSelectedSize(e.target.value);
                                          filterVariationQty(); setQuantity(1);
                                          VariationPrice();
                                        }}

                                      >
                                        <option selected disabled>Select Size</option>
                                        {productDetails?.variation?.map((item, index) => {
                                          return (
                                            <option value={item?.size} key={index}>
                                             {item?.size}
                                            </option>
                                          );
                                        })}
                                      </select>
                                    </div>
                          </div>
                          {
                            selectedSize ? (
                              <p> {selectedSize} size: only {filterVariationQty()}{" "}{filterVariationQty() > 1 ? "items" : "item"} left</p>
                            ) : (
                              null
                            )
                          }
                        </div>
                      </div>
                    </div>
                    <div className="variations">
                      <div className="row">
                        <div className="col-lg-6  quantity-wrap">
                          <div className="text">Select Quantity : </div>
                          <div className="qty-contaner">
                            <button
                              type="button"
                              className="btn qty-btn"
                              onClick={() =>
                                Decrement(productDetails?.productitem?.id)
                              }
                              disabled={quantity <= 1}
                            >
                              -
                      </button>
                            <p className="qty-num">{quantity}</p>
                            <button
                              type="button"
                              className="btn qty-btn"
                              onClick={() =>
                                Increment(productDetails?.productitem?.id)
                              }
                              disabled={filterVariationQty() == quantity}
                            >
                              +
                      </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row">
                      <div className="col-md-12 col-sm-12 col-12 pack-wrap">
                        <p className="desc-title">Choose Your Pack: </p>
                        {productDetails?.variation?.map((item, index) => {
                          return (
                            <div className={`${amount == item?.price ? "packValue selected-pack cursor_pointer" : "packValue cursor_pointer"}`} key={index}
                              onClick={(e) => SelectPacks(e, item)}
                            >
                              <p>
                              {item?.size?.replace(/["_"]/g, " ")}
                                <br />
                                <span>${item?.price}</span>
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {quantity > 0 && amount ? (
                      <p>
                        Selected pack : only {filterVariationQty()} {" "} {filterVariationQty() > 1 ? "packs" : "pack"} left
                      </p>
                    ) : null}
                  </>
                )}


                <p className="desc-title title2">Donation </p>
                <div className="row main-borderAmount">
                  <div className="col-lg-6 col-sm-12 col-12 quantity-wrap">
                    <div className="text2">Amount to donate : </div>
                    <div>
                      <select name="size" id="size" className="sizeSelect"
                        onChange={(e) => setSelectCampPrice(e.target.value)}
                      >
                        <option selected disabled>Amount</option>
                        <option value={"5"}>$5</option>
                        <option value={"12"}>$12</option>
                        <option value={"20"}>$20</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12 col-12 quantity-wrap">
                    <div className="text2">Campaign : </div>
                    <div>
                      <select name="size" id="size" className="sizeSelect"
                        onChange={(e) => setSelectCamp_id(e.target.value)}
                      >
                        <option selected disabled>Select Campaign</option>
                        {CampaignReduxData?.map((item, index) => {
                          return (
                            <option value={item?.id} key={index}>
                              {item?.title}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
                {productDetails?.current_stock > 0 ? (
                  <div className="mt-4 mb-4 cardButtonAdjust">
                    <button type="button" className="btn sizeBtn setbuttonprod"
                      onClick={(e) => AddToCartHandler(productDetails)}
                    >
                      Add To Cart &nbsp;
                     <span>
                        <ShoppingCartOutlinedIcon
                          style={{ color: "#296253", fontSize: "18px" }}
                          className="cartIcon"
                        />
                      </span>
                    </button>
                    <button
                      type="button"
                      className="btn sizeBtn"
                      onClick={(e) => AddWishListHandler(e)}
                      disabled={wishLoading}
                    >
                      {wishLoading ? "Loading.." : "Add To Wishlist"} &nbsp;
                     <span>
                        <FavoriteBorderOutlinedIcon
                          className="heartIcon"
                          style={{ color: "#296253", fontSize: "18px" }}
                        />
                      </span>
                    </button>
                  </div>
                ) : (null)}

              </div>
            </div>
          </div>

          <div className="bottom-container">
            <section className="ClientsReviewsSec">
              <div className="container">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="reviews"
                    role="tabpanel"
                    aria-labelledby="reviews-tab"
                  >
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="review-container">
                          <div>
                            <AllReviews
                              reviewData={reviewData}
                            />
                          </div>
                          <hr />
                          <div>
                            <ReviewBox
                              handleRating={handleRating}
                              rating={rating}
                              SubmitRating={SubmitRating}
                              comment={comment}
                              setComment={setComment}
                              reviewLoading={reviewLoading}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <ActionButton />

      <Footer />

    </>
  );
}

export default GeneralHydroponic;
